type Preferences = {
  [key: string]: string;
};

const preferences: Preferences = {};

export type { Preferences };

export { preferences };
